import React, { useCallback, useEffect } from "react";
import { z } from "zod";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { Grid } from "./Grid";
import { Tabs, TabsControls, TabsTrigger, TabsContent } from "../../../components/Tabs";
import { LegacyBladeHeader, BladeHeaderHeading, BladeHeaderSupertitle, BladeHeaderTitle, BladeHeaderBody, } from "../../../components/BladeHeader";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { getSelectedTabFromHash } from "../../../functional/getSelectedTabFromHash";
import { BladeCommonSchema, TabSchema } from "../../../types";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { BladeHeaderSchema } from "../../../schemas/BladeHeader";
import { RichText } from "../../../components/RichText";
export const GameSpecsPropsSchema = BladeCommonSchema.extend({
    header: BladeHeaderSchema.optional(),
    tabs: z.array(TabSchema),
});
export const GameSpecsContractSchema = GameSpecsPropsSchema.extend({
    type: z.literal("gameSpecs"),
});
const _GameSpecs = ({ header, tabs, className, fragmentId, ...props }) => {
    const [tabValue, setTabValue] = React.useState(tabs[0].id);
    const syncTabsWithHistory = useCallback(() => {
        const tabAnchor = getSelectedTabFromHash({
            hash: window.location.hash,
            bladeId: fragmentId || "game-specs",
            tabIds: tabs.map((tab) => tab.id),
        });
        if (tabAnchor) {
            setTabValue(tabAnchor);
        }
    }, [fragmentId, tabs]);
    useEffect(() => {
        syncTabsWithHistory();
        window.addEventListener("popstate", syncTabsWithHistory);
        return () => window.removeEventListener("popstate", syncTabsWithHistory);
    }, [tabValue, syncTabsWithHistory]);
    const onTabChange = (value) => {
        const newUrl = new URL(window.location.href);
        newUrl.hash = `${fragmentId}--${value}`;
        history.pushState({}, "", newUrl);
        return setTabValue(value);
    };
    const headerContent = hasVisibleContent(header);
    return (React.createElement(Blade, { className: className, "data-testid": fragmentId, ...props, id: fragmentId },
        header && headerContent && (React.createElement(LegacyBladeHeader, null,
            React.createElement(BladeHeaderHeading, null,
                header.supertitle && React.createElement(BladeHeaderSupertitle, null, header.supertitle),
                header.title && (React.createElement(BladeHeaderTitle, null,
                    React.createElement("h2", null, header.title)))),
            header?.description ? (React.createElement(BladeHeaderBody, null,
                React.createElement(RichText, { ...header.description }))) : null)),
        React.createElement(Tabs, { value: tabValue, onValueChange: onTabChange },
            React.createElement(TabsControls, { loop: false }, tabs.map((tab) => {
                const tabContentId = `${fragmentId}--${tab.id}`;
                return (React.createElement(TabsTrigger, { id: tabContentId, key: tab.id, value: tab.id, disabled: false, "data-testid": `trigger-${tab.id}` }, tab.heading));
            })),
            React.createElement("hr", { className: "tab-controls-divider", "data-testid": "divider" }),
            tabs.map((tab) => {
                return (React.createElement(TabsContent, { value: tab.id, "data-testid": `content-${tab.id}`, key: tab.id }, tab.groups.map((tabGroup) => (React.createElement(Grid, { ...tabGroup, key: tabGroup.heading })))));
            }))));
};
export const GameSpecs = styled(_GameSpecs) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=GameSpecs.js.map